'use client';
import usePlacesService from 'react-google-autocomplete/lib/usePlacesAutocompleteService';
import React, { useState } from 'react';

export default function PlacesAutocomplete({
  initialLocation,
  location,
  setLocation,
}) {
  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = usePlacesService({
    options: {
      input: '',
      types: ['(regions)'],
      componentRestrictions: { country: 'us' },
    },
  });
  const [isReadyForSelection, setReadyForSelection] = useState(true);

  const placeholder = location.address || 'location';

  const handleChange = (address) => {
    setReadyForSelection(true);
    setLocation((prevLocation) => ({
      ...prevLocation,
      address: address,
    }));
  };

  const selectAddressAction = (item) => () => {
    try {
      setReadyForSelection(false);
      placesService?.getDetails(
        {
          fields: ['geometry'],
          placeId: item.place_id,
        },
        (placeDetails) => {
          const lat = placeDetails?.geometry?.location?.lat?.();
          const lng = placeDetails?.geometry?.location?.lng?.();

          if (typeof lat !== 'number' || typeof lng !== 'number') {
            // Still update the visible address, but keep existing lat/lng.
            setLocation((prev) => ({
              ...prev,
              address: item.description,
              isInputAllowed: false,
            }));
            return;
          }

          setLocation({
            latitude: lat,
            longitude: lng,
            address: item.description,
            isInputAllowed: false,
          });
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const renderItem = (placePrediction) => {
    const { structured_formatting } = placePrediction;
    return (
      <div
        key={placePrediction.place_id}
        className="suggestion-item smart-input--list-item"
        role="option"
        onClick={selectAddressAction(placePrediction)}
      >
        <strong>{structured_formatting.main_text}</strong>{' '}
        <small>{structured_formatting.secondary_text}</small>
      </div>
    );
  };

  const clearSearch = () => {
    setReadyForSelection(false);
    setLocation({
      address: '',
      latitude: initialLocation?.lat,
      longitude: initialLocation?.lng,
      isInputAllowed: true,
    });
  };

  const handleAddressClick = () => {
    if (!location.isInputAllowed) {
      setLocation({
        ...location,
        isInputAllowed: true,
      });
    }
  };
  return (
    <div className="search-input-wrap">
      {!location.isInputAllowed ? (
        <span
          className="schedule-location-input scheduling-address"
          onClick={handleAddressClick}
        >
          <span className="schedule-location-value">{location.address}</span>
        </span>
      ) : (
        <input
          id="search-field"
          className="search-input"
          value={location.address}
          onChange={(evt) => {
            getPlacePredictions({ input: evt.target.value });
            handleChange(evt.target.value);
          }}
          placeholder={placeholder}
        />
      )}
      {location.address && (
        <button className="search-clear" onClick={clearSearch}>
          <svg
            fill="#9698a6"
            height="16px"
            width="16px"
            version="1.1"
            id="Capa_1"
            viewBox="0 0 490 490"
          >
            <polygon
              points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490
              489.292,457.678 277.331,245.004 489.292,32.337 "
            />
          </svg>
        </button>
      )}
      {!isPlacePredictionsLoading &&
        isReadyForSelection &&
        placePredictions &&
        placePredictions.length > 0 && (
          <div
            style={{
              zIndex: 9,
            }}
          >
            {placePredictions.map(renderItem)}
          </div>
        )}
    </div>
  );
}
